import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import Box from '@mui/material/Box';
import Cookies from 'universal-cookie';
import { Button } from '@mui/material';

import api from 'utils/api';
import DataTable from 'components/common/DataTable';
import CustomContainer from 'components/CustomContainer';

const customStyles = {
  headRow: {
    style: {
      color: 'white',
      backgroundColor: '#6699CC' //blue
    }
  },
  headCells: {
    style: {
      fontSize: '16px',
      fontWeight: 'bold',
      border: '1px solid #ddd', // add border to header cells
      justifyContent: 'center'
    }
  },
  rows: {
    style: {
      minHeight: '56px',
      '&:nth-child(even)': {
        backgroundColor: '#FFFFFF' //white
      },
      '&:nth-child(odd)': {
        backgroundColor: '#D0D5E8' //grey
      },
      border: '1px solid #ddd' // add border to rows
    }
  },
  cells: {
    style: {
      fontSize: '14px',
      paddingLeft: '8px',
      paddingRight: '8px',
      width: '20%',
      borderRight: '1px solid #ddd', // add right border to cells
      justifyContent: 'center'
    }
  }
};

const OwnersTable = forwardRef((props: any, ref: any) => {
  const [fetchedData, setFetchedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const cookies = new Cookies();
  const [refreshTable, setRefreshTable] = useState(true);
  useImperativeHandle(ref, () => ({
    refresh() {
      setRefreshTable(true);
    }
  }));

  useEffect(() => {
    if (refreshTable) {
      setLoading(true);
      fetchTableData().then(() => setLoading(false));
      setRefreshTable(false);
    }
  }, [refreshTable]);

  const handleView = (id: string) => {
    props.handleView(id);
  };

  const columns: any = [
    {
      name: 'Owner Id',
      selector: (owner: any) => owner.ownerIdStr
    },
    {
      name: 'Name',
      selector: (owner: any) => owner.name
    },
    {
      name: 'Actions',
      selector: (owner: any) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Button
            type='button'
            variant='secondary'
            data-cy='view-owner-button'
            color='dark'
            onClick={() => {
              handleView(owner.id);
            }}
          >
            View
          </Button>
        </div>
      )
    }
  ];

  const fetchTableData = async () => {
    try {
      const owners = await api.get('/admin/owners');
      setFetchedData(owners.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CustomContainer>
      <div style={{ height: 32 }} />
      <Box sx={{ width: '100%' }}>
        <DataTable
          title=''
          columns={[...columns]}
          data={fetchedData}
          progressPending={loading}
          pagination
          customStyles={customStyles}
        />
      </Box>
    </CustomContainer>
  );
});

export default OwnersTable;
